export default __webpack_public_path__ + "static/media/anh-bia.90fdca8f.jpg";